import React, { Component } from 'react';
import { Avatar, Drawer, List, Table, Tooltip } from 'antd';
import moment from "moment-jalaali";
import { PriceFormat } from '../scripts/helpers';
import { Constants } from '../scripts/settings';
import Resources from '../scripts/resources';

class SpecialOfferView extends Component {
    render() {
        const { data, onClose, visible } = this.props;

        const columns = [{
            title: Resources.title,
            dataIndex: 'name'
        }, {
            title: Resources.image,
            dataIndex: 'gallery',
            width: '50px',
            render: val => {
                const image = val && val.length ? val[0].image : null;
                return <Tooltip title={<Avatar src={`${Constants.imagePathProduct}${image}`} shape="square" size={200} />}><Avatar src={`${Constants.imagePathProduct}${image}`} shape="square" size="small" /></Tooltip>;
            }
        }, {
            title: Resources.barcode,
            dataIndex: 'code',
            className: 'col-center',
            width: '150px'
        }, {
            title: Resources.count,
            dataIndex: 'pivot',
            key: 'count',
            className: 'col-center',
            width: '60px',
            render: val => val.count
        }, {
            title: `${Resources.price} (${Resources.rial})`,
            dataIndex: 'priceOne',
            className: 'col-center',
            width: '120px',
            render: (val, record) => PriceFormat(`${val}/${record.priceTwo}/${record.priceThree}`)
        }, {
            title: `${Resources.price} ${Resources.new} (${Resources.rial})`,
            dataIndex: 'pivot',
            className: 'col-center',
            width: '120px',
            render: val => PriceFormat(val.offer)
        }];

        return (
            <Drawer visible={visible} closable={false} onClose={onClose} placement="left" width={600}>
                <List>
                    <List.Item>
                        <List.Item.Meta title={`${Resources.count} ${Resources.product}`} description={data.product && data.product.length ? data.product.length : '0'} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.startDate} description={moment(data.startDate).format(Constants.jDateFormat)} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.endDate} description={moment(data.endDate).format(Constants.jDateFormat)} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.status} description={PriceFormat(!!parseInt(data.status) ? Resources.active : Resources.inactive)} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.products} />
                    </List.Item>
                    <Table
                        columns={columns}
                        dataSource={data.product}
                        pagination={false}
                        size="small"
                        rowKey="id"
                    />
                </List>
            </Drawer>
        );
    }
};

export default SpecialOfferView;